import React from "react";
import { useTranslation } from "react-i18next";
import { useEditProjectExpense } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Identifiable, ProjectExpense } from "@planzone/dto";
import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function ProjectExpenseEdition({ projectExpense, project, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, editProjectExpense } =
    useEditProjectExpense(projectExpense);
  const [formData, setFormData] =
    React.useState<Identifiable<ProjectExpense>>(projectExpense);

  return (
    <Modal
      header={t("projectBudgetSynthesis.expenses.edition.title")}
      close={cancel}
    >
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          !isRequestPending &&
            editProjectExpense({
              projectExpense,
              nextProjectExpense: formData,
            });
        }}
      >
        <Form formData={formData} project={project} edit={setFormData} />
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("projectBudgetSynthesis.expenses.edition.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("projectBudgetSynthesis.expenses.edition.confirm")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ProjectExpenseEdition };
